import React from 'react';
import './ProductsPage.css';

const ProductsPage: React.FC = () => {
  return (
    <div className="products-page">
      <h1>Danh Sách Sản Phẩm</h1>
      <p>Trang sản phẩm đang được phát triển...</p>
      <p>Tính năng sẽ bao gồm: Danh sách sản phẩm, Filter, Sort, Pagination</p>
    </div>
  );
};

export default ProductsPage;
